// extracted by mini-css-extract-plugin
export default {"container":"SelectedTeamDetails_container__HyLPk","teamName":"SelectedTeamDetails_teamName__7CEkJ","team":"SelectedTeamDetails_team__0mL81"};